import proxy from "./proxy";
import proxyTitle from "./proxyTitle";
import textValue from "./textValue";
import dateTime from "./dateTime";
import emptyFilter from "./emptyFilter";
import multipleFiles from "./multipleFiles";
import textValueByLast from "./textValueByLast";
import timeAgo from "./timeAgo";
import htmlImage from "./htmlImage";
import splitArrow from "./splitArrow";
import htmlLink from "./htmlLink";
import imgFormat from "./imgFormat";
import expressFilter from "./expressFilter";
import fileSuffixIcon from "./fileSuffixIcon";
import periodTime from "./periodTime";
import htmlContext from "./htmlContext";
//objectToString已弃用，后续开发中请勿在使用。
// import objectToString from "./objectToString";

function install(Vue) {
  Vue.use(proxy);
  Vue.use(proxyTitle);
  Vue.use(textValue);
  Vue.use(dateTime);
  Vue.use(emptyFilter);
  Vue.use(multipleFiles);
  Vue.use(textValueByLast);
  Vue.use(timeAgo);
  Vue.use(htmlImage);
  Vue.use(splitArrow);
  Vue.use(htmlLink);
  Vue.use(imgFormat);
  Vue.use(fileSuffixIcon);
  Vue.use(periodTime);
  Vue.use(expressFilter);
  Vue.use(htmlContext);
  //objectToString已弃用，后续开发中请勿在使用。
  // Vue.use(objectToString);
}

export default install;

export { install, proxy, proxyTitle, textValue, dateTime, emptyFilter, multipleFiles, textValueByLast, timeAgo, htmlImage, splitArrow, periodTime, expressFilter, htmlContext };
